module.exports = __webpack_public_path__ + "media/newstyle/images/stars_5-0946cbd46e80f324d4eb75b36cd48e30.svg";